module.exports = __webpack_public_path__ + "static/img/apple-store-badge-es-AR.bbd6b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-es-AR.png
// module id = cBfw
// module chunks = 1